import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Table, Container, Row, Col, Form } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import "../../../node_modules/react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import $ from 'jquery';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';


import * as Common from '../Common';
import Dialog from '../Dialog';
import InwardView from './InwardView';

function InwardCreditReceived(props) {
    const navigate = useNavigate();
    const [refreshCounter, setRefreshCounter] = useState(0);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [rightInwardCreditReceived, setRightInwardCreditReceived] = useState([]);

    const [inwardDetail, setInwardDetail] = useState([]);
    const [coverListData, setCoverListData] = useState([]);
    const [reqHeader, setReqHeader] = useState([]);

    const [totalCover, setTotalCover] = useState(0);
    const [totalCoverInr, setTotalCoverInr] = useState(0);
    const [avgCoverRate, setAvgCoverRate] = useState(0);

    const [reqCreditDate, setReqCreditDate] = useState(new Date());
    const [reqCreditAmount, setReqCreditAmount] = useState(0);
    const [reqCreditRefNum, setReqCreditRefNum] = useState("");

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'INWARDCREDITRECEIVED'], function (result) {
                let resp = JSON.parse(result);

                setRightInwardCreditReceived(resp);
                if (resp.query === "1") {
                    Common.callApi(Common.apiInward, [sid, 'getdetail', props.srno], function (result) {
                        let resp = JSON.parse(result);

                        if (resp.status === "MSG0002") {
                            navigate('/');
                        }
                        $('.loader').hide();

                        setInwardDetail(resp);
                        setCoverListData(resp.cover);
                        calcTotalCover(resp.cover, resp.data[0]);
                        setReqHeader(resp.data[0]);
                        setRefreshCounter(refreshCounter + 1);
                    });
                } else {
                    navigate('/'); // no query right
                }
            });

            setOnceRun(true);
        }
    }, [onceRun, sid, navigate, props]);
    function calcTotalCover(nv, header) {
        let tc = 0;
        let tcinr = 0;
        for (var i = 0; i < nv.length; i++) {
            tc = tc * 1 + (nv[i].tric_value) * 1;
            tcinr = ((1 * (nv[i].tric_value * 1) * (nv[i].tric_rate * 1)) + 1 * tcinr).toFixed(2);

            console.log(tcinr);

        }
        setTotalCover(tc);
        setTotalCoverInr(tcinr);
        setAvgCoverRate((1 * tcinr / tc).toFixed(2));
    }

    function btnBackClick() {
        props.callInProgress();
    }

    function btnCreditConfirm() {
        $('.loader').show();
        var obj = {
            reqSrno: props.srno,
            reqCreditDate: Common.dateYMD(reqCreditDate),
            reqCreditAmount: reqCreditAmount,
            reqCreditRefNum: reqCreditRefNum
        }
        Common.callApi(Common.apiInward, [sid, 'creditconfirm', JSON.stringify(obj)], function (result) {
            let resp = JSON.parse(result);

            if (resp.err === "") {
                setMsgText(resp.msg);
                setMsgBox(true);
                btnBackClick();
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
            $('.loader').hide();
            setRefreshCounter(refreshCounter + 1);
        });
    }
    return (
        <>
            <Container fluid>
                <Row>
                    <Col>
                        <Button variant="outline-danger" size="sm" onClick={(e) => btnBackClick()} >Back</Button>&nbsp;
                    </Col>
                </Row>
                {
                    refreshCounter > 0 ?
                        <>
                            <Row>
                                <Col>
                                    <InwardView rhdata={inwardDetail} rc={refreshCounter}></InwardView>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <h5>Cover List</h5>
                                </Col>
                            </Row>
                            <Row>
                                <Col>Total Cover Value : {totalCover}&nbsp;&nbsp;Total Cover INR : {totalCoverInr}&nbsp;&nbsp;Avg Rate : {avgCoverRate}</Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Table responsive striped bordered hover>
                                        <thead>
                                            <tr>
                                                <td>Issuer</td>
                                                <td>Deal Id</td>
                                                <td>Deal Rate</td>
                                                <td>Deal Value</td>
                                                <td>Deal INR</td>
                                                <td>Value Date</td>
                                                <td>Tenure</td>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {coverListData.map((res) =>
                                                <tr key={res.tric_lineno}>
                                                    <td>{res.tric_bank}&nbsp;:&nbsp;{res.issuer_name}</td>
                                                    <td>{res.tric_dealno}</td>
                                                    <td>{res.tric_rate}</td>
                                                    <td>{res.tric_value}</td>
                                                    <td>{(1 * res.tric_value * res.tric_rate).toFixed(2)}</td>
                                                    <td>{res.tric_valuedatedmy}</td>
                                                    <td>{res.tric_dealtenure}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </> : null
                }

                {
                    rightInwardCreditReceived.add === "1" && reqHeader.reqi_paymentcredited === "0" ? <>
                        <Row>
                            <Col>
                                <Form.Group>
                                    <Form.Label>Credit Date<span className="mandatory">*</span></Form.Label>
                                    <DatePicker className="form-control"
                                        selected={reqCreditDate}
                                        onChange={(date) => setReqCreditDate(date)}
                                        isClearable={true}
                                        dateFormat="dd/MM/yyyy"
                                        showYearDropdown
                                        showMonthDropdown
                                        useShortMonthInDropdown
                                        dropdownMode="select"
                                        peekNextMonth
                                        customInput={
                                            <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                        }
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group >
                                    <Form.Label>Credit Amount<span className="mandatory">*</span></Form.Label>
                                    <Form.Control type="text" placeholder="Credit Amount" maxLength={10}
                                        onChange={(e) => Common.validateDecValue(e.target.value, setReqCreditAmount)}
                                        value={reqCreditAmount} autoComplete="off"
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={6} >
                                <Form.Group >
                                    <Form.Label>Reference Number<span className="mandatory">*</span></Form.Label>
                                    <Form.Control type="text" placeholder="Reference Number" maxLength={100}
                                        onChange={(e) => setReqCreditRefNum(e.target.value)}
                                        value={reqCreditRefNum} autoComplete="off"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row><Col>&nbsp;</Col></Row>
                        <Row>
                            <Col>
                                <Button variant="outline-primary" size="sm" onClick={(e) => btnCreditConfirm()} >Confirm</Button>
                            </Col>
                        </Row>
                    </> : null
                }

                <Row><Col>&nbsp;</Col></Row>
                <Row><Col>&nbsp;</Col></Row>
                <Row><Col>&nbsp;</Col></Row>
            </Container>
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div>
        </>
    )
}
export default InwardCreditReceived;